import { FC } from "react";

interface HeroProps {
    scrollProgress?: number;
}

const Hero: FC<HeroProps> = ({ scrollProgress }) => {

    return (
        <section className="w-full h-dvh snap-start relative bg-black flex flex-col">
            <div className="w-full flex flex-col gap-4 mb-[72px] items-center justify-center pt-[150px]">
                <h1 className="font-satoshi font-black text-[32px] md:text-h1 leading-[100%] text-center w-full text-[#EDEDED]">Meet Curo</h1>
                <p className="font-satoshi font-light text-[20px] md:text-2xl !leading-[100%] tracking-[-1%] text-[#EBEBEB] text-center">Your AI-powered Learning Companion</p>
            </div>

            <div className="flex flex-col gap-4 ">
                <p className="font-satoshi font-normal text-xs leading-[20px] md:text-sm tracking-[5%] text-center text-[#6A6A6A]">
                    Backed by
                </p>
                <div className="flex flex-wrap items-center md:flex-row w-full justify-center ">
                    <div className="py-4 px-6 border-[0.25px] border-[#959595] w-[160px] h-[60px] flex items-center justify-center">
                        <img src="/landingpage/elevenlabs.png" alt="ElevenLabs" />
                    </div>
                    <div className="py-4 px-6 border-[0.25px] border-[#959595] w-[160px] h-[60px] flex items-center justify-center">
                        <img src="/landingpage/google.png" alt="Google" />
                    </div>
                    <div className="py-4 px-6 border-[0.25px] border-[#959595] w-[160px] h-[60px] flex items-center justify-center">
                        <img src="/landingpage/aws.png" alt="AWS" />
                    </div>
                    <div className="py-4 px-6 border-[0.25px] border-[#959595] w-[160px] h-[60px] flex items-center justify-center">
                        <img src="/landingpage/microsoft.png" alt="Microsoft" className="object-cover w-full h-full" />
                    </div>
                </div>
            </div>

            <div className="flex-1 relative bg-black overflow-hidden">
                {/* Background image */}


                {/* Grid background - layer 1 (bottom) */}
                <div className="absolute inset-0 bg-cover w-full h-full bg-center bg-repeat z-0" style={{ backgroundImage: 'url(/landingpage/Grid.svg)' }}></div>

                {/* Ellipse blur overlay - layer 2 (middle) */}
                <div
                    className="absolute inset-0 z-10"
                    style={{
                        background: 'radial-gradient(ellipse at center, #A7A7A71A 0%, black 30%)',
                        filter: 'blur(100px)'
                    }}
                ></div>

                {/* Circular gradient at bottom - layer 3 (top) */}
                <div
                    className="absolute bottom-0 left-1/2 -translate-x-1/2 z-20 bg-transparent rounded-full"
                    style={{
                        width: '689px',
                        height: '689px',
                        background: 'radial-gradient(22.97% 22.97% at 50.04% 22.97%, rgba(255, 113, 52, 0.15) 0%, rgba(255, 141, 28, 0.15) 100%) ',
                        filter: 'blur(480.4px)',
                        transform: 'translateX(-50%) translateY(50%)'
                    }}
                ></div>
            </div>

            {/* Mobile-only static bottom panel — closed state, no JS animations to avoid scroll-lag */}
            <div
                className="md:hidden absolute left-1/2 -translate-x-1/2 z-30 pointer-events-none"
                style={{
                    bottom: '0px',
                    width: 'calc(100vw - 30px)',
                    height: '80px'
                }}
            >
                {/* Curo mascot sitting above the panel */}
                <img
                    src="/curohome.svg"
                    className="w-[117px] object-cover absolute left-1/2 -translate-x-1/2 translate-y-[24px] -z-[1]"
                    style={{ bottom: '80px' }}
                />
                <div
                    className="w-full h-full landing-bg-radial-gradient"
                    style={{
                        borderTopLeftRadius: '39.2px',
                        borderTopRightRadius: '39.2px',
                        borderBottomLeftRadius: '0px',
                        borderBottomRightRadius: '0px'
                    }}
                />
            </div>

        </section>
    )
}

export default Hero;